import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_chip = _resolveComponent("chip")!

  return (_openBlock(), _createBlock(_component_chip, {
    text: _ctx.text,
    rounded: _ctx.rounded,
    "theme-color": null,
    class: _normalizeClass(["indicator", _ctx.clickable ? '' : 'indicator-no-click'])
  }, null, 8, ["text", "rounded", "class"]))
}